import type { ReactNode } from 'react';
import { Box, Stack, type SxProps } from '@mui/material';
import { mergeSx } from '../../utils/styles';

const defaultStyles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    maxHeight: 'inherit',
    minHeight: 0,
  },
  swipeHandleContainer: {
    display: { xs: 'flex', md: 'none' },
    justifyContent: 'center',
    flexShrink: 0,
    pb: 1.5,
  },
  swipeHandle: {
    width: 44,
    height: 4,
    borderRadius: 999,
    backgroundColor: 'neutral.400',
  },
  scrollArea: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
} as const;

type SwipeableModalShellProps = {
  children: ReactNode;
  sx?: SxProps;
  swipeHandleSx?: SxProps;
  testId?: string;
};

const SwipeableModalShell = ({ children, sx, swipeHandleSx, testId }: SwipeableModalShellProps) => (
  <Box sx={mergeSx(defaultStyles.root, sx)} data-testid={testId}>
    <Box aria-hidden='true' sx={defaultStyles.swipeHandleContainer}>
      <Box
        data-testid={testId ? `${testId}-swipe-handle` : undefined}
        sx={mergeSx(defaultStyles.swipeHandle, swipeHandleSx)}
      />
    </Box>
    {children}
  </Box>
);

type SwipeableModalShellScrollAreaProps = {
  children: ReactNode;
  sx?: SxProps;
  testId?: string;
};

const ScrollArea = ({ children, sx, testId }: SwipeableModalShellScrollAreaProps) => (
  <Stack sx={mergeSx(defaultStyles.scrollArea, sx)} data-testid={testId}>
    {children}
  </Stack>
);

SwipeableModalShell.ScrollArea = ScrollArea;

export default SwipeableModalShell;
